import {
  defaultExternalCollaboration,
  defaultNewArrivalNotice,
  defaultNowStatus,
  defaultOpac,
  defaultUserBase,
  defaultUserGroup,
  defaultUserPersonal,
  exists,
  ExternalCollaboration,
  ExternalCollaborationFromJSON,
  HistoryCount,
  HistoryCountFromJSON,
  RequestReserveHistoryCount,
  RequestReserveHistoryCountFromJSON,
  LendCollection,
  LendCollectionFromJSON,
  MailHistory,
  MailHistoryFromJSON,
  NewArrivalNotice,
  NewArrivalNoticeFromJSON,
  NowStatus,
  NowStatusFromJSON,
  Opac,
  OpacFromJSON,
  RemindHistory,
  RemindHistoryFromJSON,
  ReserveCancelCollection,
  ReserveCancelCollectionFromJSON,
  ReserveCollection,
  ReserveCollectionFromJSON,
  UserBase,
  UserBaseFromJSON,
  UserFamily,
  UserFamilyFromJSON,
  UserGroup,
  UserGroupFromJSON,
  UserMemo,
  UserMemoFromJSON,
  UserNote,
  UserNoteFromJSON,
  UserPersonal,
  UserPersonalFromJSON
} from '@/api'

export interface User {
  base: UserBase
  personal: UserPersonal
  group: UserGroup
  familyUsers: UserFamily[]
  memos: UserMemo[]
  notes: UserNote[]
  newArrivalNotice: NewArrivalNotice
  mailHistories: MailHistory[]
  opac: Opac
  nowStatus: NowStatus
  lendCountHistory: HistoryCount[]
  studentLendCountHistory: HistoryCount[]
  reserveCountHistory: HistoryCount[]
  remindCountHistory: HistoryCount[]
  requestReserveCountHistory: RequestReserveHistoryCount[]
  lendCollections: LendCollection[]
  reserveCollections: ReserveCollection[]
  remindHistories: RemindHistory[]
  reserveCancelCollections: ReserveCancelCollection[]
  todaysLendCollections: LendCollection[]
  externalCollaboration: ExternalCollaboration
}

export function UserFromJSON(json: any): User {
  return {
    base: UserBaseFromJSON(json.base),
    personal: exists(json, 'personal')
      ? UserPersonalFromJSON(json.personal)
      : defaultUserPersonal(),
    group: exists(json, 'group')
      ? UserGroupFromJSON(json.group)
      : defaultUserGroup(),
    familyUsers: exists(json, 'family_users')
      ? (json.family_users as any[]).map(UserFamilyFromJSON)
      : [],
    memos: exists(json, 'memos')
      ? (json.memos as any[]).map(UserMemoFromJSON)
      : [],
    notes: exists(json, 'notes')
      ? (json.notes as any[]).map(UserNoteFromJSON)
      : [],
    newArrivalNotice: exists(json, 'new_arrival_notice')
      ? NewArrivalNoticeFromJSON(json.new_arrival_notice)
      : defaultNewArrivalNotice(),
    mailHistories: exists(json, 'mail_histories')
      ? (json.mail_histories as any[]).map(MailHistoryFromJSON)
      : [],
    opac: exists(json, 'opac') ? OpacFromJSON(json.opac) : defaultOpac(),
    nowStatus: exists(json, 'now_status')
      ? NowStatusFromJSON(json.now_status)
      : defaultNowStatus(),
    lendCountHistory: exists(json, 'lend_count_history')
      ? (json.lend_count_history as any[]).map(HistoryCountFromJSON)
      : [],
    studentLendCountHistory: exists(json, 'student_lend_count_history')
      ? (json.student_lend_count_history as any[]).map(HistoryCountFromJSON)
      : [],
    reserveCountHistory: exists(json, 'reserve_count_history')
      ? (json.reserve_count_history as any[]).map(HistoryCountFromJSON)
      : [],
    remindCountHistory: exists(json, 'remind_count_history')
      ? (json.remind_count_history as any[]).map(HistoryCountFromJSON)
      : [],
    requestReserveCountHistory: exists(json, 'request_reserve_history')
      ? (json.request_reserve_history as any[]).map(
          RequestReserveHistoryCountFromJSON
        )
      : [],
    lendCollections: exists(json, 'lend_collections')
      ? (json.lend_collections as any[]).map(LendCollectionFromJSON)
      : [],
    reserveCollections: exists(json, 'reserve_collections')
      ? json.reserve_collections.map(ReserveCollectionFromJSON)
      : [],
    remindHistories: exists(json, 'remind_histories')
      ? json.remind_histories.map(RemindHistoryFromJSON)
      : [],
    reserveCancelCollections: exists(json, 'reserve_cancel_collections')
      ? json.reserve_cancel_collections.map(ReserveCancelCollectionFromJSON)
      : [],
    todaysLendCollections: exists(json, 'todays_lend_collections')
      ? (json.todays_lend_collections as any[]).map(LendCollectionFromJSON)
      : [],
    externalCollaboration: exists(json, 'external_collaboration')
      ? ExternalCollaborationFromJSON(json.external_collaboration)
      : defaultExternalCollaboration()
  }
}

export const defaultUser = (): User => ({
  base: defaultUserBase(),
  personal: defaultUserPersonal(),
  group: defaultUserGroup(),
  familyUsers: [],
  memos: [],
  notes: [],
  newArrivalNotice: defaultNewArrivalNotice(),
  mailHistories: [],
  opac: defaultOpac(),
  nowStatus: defaultNowStatus(),
  lendCountHistory: [],
  studentLendCountHistory: [],
  reserveCountHistory: [],
  requestReserveCountHistory: [],
  remindCountHistory: [],
  lendCollections: [],
  reserveCollections: [],
  remindHistories: [],
  reserveCancelCollections: [],
  todaysLendCollections: [],
  externalCollaboration: defaultExternalCollaboration()
})
